import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import fr from '../locales/fr/translation.json';
import en from '../locales/en/translation.json';
import {
  DEFAULT_INTERFACE_LANGUAGE,
  detectBrowserInterfaceLanguage,
  getLastUsedInterfaceLanguage,
} from '../constants/interfaceLanguages';

const initialLanguage = getLastUsedInterfaceLanguage() ?? detectBrowserInterfaceLanguage();

i18n
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
    },
    lng: initialLanguage,
    fallbackLng: DEFAULT_INTERFACE_LANGUAGE,
    interpolation: { escapeValue: false },
    returnEmptyString: false,
  });

export default i18n;
